module.exports = __webpack_public_path__ + "img/Flag_of_Pakistan.52975d36.svg";